import React from 'react';
import './NotificationMenuItem.scss';
import CommentNotificationContent from './CommentNotificationContent';

const NotificationMenuItem = ({ notification, markAsRead, setActiveNotification }) => {

	const getNotificationType = (type) => {
		switch (type?.toLowerCase()) {
			case "review_comment":
				return <CommentNotificationContent notification={notification} markAsRead={markAsRead} action='commented on' setActiveNotification={setActiveNotification}/>
			case "review_approved":
				return  <CommentNotificationContent notification={notification} markAsRead={markAsRead} noComment action='approved' setActiveNotification={setActiveNotification}/>
			case "review_rejected":
				return  <CommentNotificationContent notification={notification} markAsRead={markAsRead} action='rejected' setActiveNotification={setActiveNotification}/>
			default:
				return <CommentNotificationContent notification={notification} markAsRead={markAsRead} noComment action={notification.content.replace(".", " for")} systemMessage setActiveNotification={setActiveNotification}/>
		}
	}

	return getNotificationType(notification.actionType)
};

export default NotificationMenuItem;